import React, { Component } from "react";
import { Input, Form, Button, Icon, Alert, Spin } from "antd";
import axios from "axios";

import { FormContainer, Header, Footer, ContactUsLink } from "../../components";

const FORM_STATUS = {
  OPEN: "OPEN",
  SUBMITTING: "SUBMITTING",
  SUBMIT_SUCCESS: "SUBMIT_SUCCESS",
  SUBMIT_ERROR: "SUBMIT_ERROR"
};

class RequestTrial extends Component {
  state = {
    confirmDirty: false,
    formStatus: FORM_STATUS.OPEN
  };

  handleSubmit = e => {
    e.preventDefault();
    const self = this;
    this.props.form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        self.setState({
          formStatus: FORM_STATUS.SUBMITTING
        });
        const url = "https://api.utils.pdview.com.au/sendemailtocompany";
        axios
          .get(url, {
            params: {
              Subject: `Trial request form submitted on ${
                window.location.origin
              } by ${fieldsValue["email"]}`,
              Message: JSON.stringify(fieldsValue, null, 2),
              TargetArn:
                "arn:aws:sns:ap-southeast-2:734239462087:SendEmailToCompanyTopic"
            }
          })
          .then(function(response) {
            self.setState({
              formStatus: FORM_STATUS.SUBMIT_SUCCESS
            });
          })
          .catch(function(error) {
            self.setState({
              formStatus: FORM_STATUS.SUBMIT_ERROR
            });
          });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { formStatus } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 18,
          offset: 6
        }
      }
    };

    return (
      <div>
        <Header />
        <FormContainer formTitle={"Request trial"}>
          <Form onSubmit={this.handleSubmit}>
            <Form.Item {...formItemLayout} label={"Email"}>
              {getFieldDecorator("email", {
                rules: [
                  {
                    required: true,
                    message: "Please enter your email address"
                  },
                  {
                    type: "email",
                    message: "Invalid email address"
                  }
                ]
              })(
                <Input
                  placeholder={"you@company.com.au"}
                  prefix={<Icon type="mail" />}
                />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="Message">
              {getFieldDecorator("message", {
                rules: [
                  {
                    required: true,
                    message: "Please enter your message"
                  }
                ]
              })(<Input.TextArea autosize={{ minRows: 4 }} />)}
            </Form.Item>
            <Form.Item {...tailFormItemLayout}>
              <Button
                type="primary"
                htmlType="submit"
                disabled={
                  formStatus === FORM_STATUS.SUBMITTING ||
                  formStatus === FORM_STATUS.SUBMIT_SUCCESS
                }
              >
                Submit request
              </Button>

              {formStatus === FORM_STATUS.SUBMITTING && (
                <Spin size="large">
                  <Alert
                    showIcon
                    message="Submitting your request..."
                    type="info"
                    description="Please wait while your request is getting submitted. This may take a few seconds."
                  />
                </Spin>
              )}
              {formStatus === FORM_STATUS.SUBMIT_SUCCESS && (
                <Alert
                  type="success"
                  showIcon
                  message="Request submitted successfully"
                  description="We have received your request. We will contact you in 1-2 business days."
                />
              )}
              {formStatus === FORM_STATUS.SUBMIT_ERROR && (
                <Alert
                  type="error"
                  showIcon
                  message="Something went wrong"
                  description="There was an error in processing your request. Try submitting again. If error persists, contact pdView directly."
                />
              )}
            </Form.Item>
          </Form>
          <ContactUsLink />
        </FormContainer>
        <Footer />
      </div>
    );
  }
}

export default Form.create()(RequestTrial);



// WEBPACK FOOTER //
// ./src/views/request_trial/RequestTrial.jsx